<template>
  <el-dialog
    title=""
    :visible.sync="isOpen"
    width="9rem"
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    custom-class="success-dialog"
  >
    <div class="sign-success">
      <img src="../../../assets/image/login/success.png"/>
      <div class="sign-success_title">You are verified!</div>
      <div class="sign-success_tip">Please add wells first, then mint Rep.</div> 
    </div>
    <div class="addbtn">
       <el-button type="primary" @click="close('add')">Add Well</el-button>
    </div>
    <div class="closebtn">
      <el-button type="text" @click="close('close')">Skip</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOpen: false,
      count:3
    };
  },
  computed: {},
  methods: {
    open() {
      this.isOpen = true;
    },
    close(type) {
      this.isOpen = false;
      this.$emit("close",type)
    }
  },
  created() {},
  mounted() {},
  watch: {}
};
</script>
<style lang="scss" scoped>
.sign-success{
  text-align: center;
  padding-bottom:0.4rem;
  img{
    width:1.6rem;
    margin-bottom:0.4rem;
  }
  .sign-success_title{
    color:#000;
    font-size: 0.32rem;
    line-height: 0.4rem;
    font-weight: bold;
  }
  .sign-success_tip{
    color:#B4B4B4;
    font-size: 0.18rem;
    margin-top:0.12rem;
  }
}
.addbtn{
  text-align: center;
}
.closebtn{
  text-align: center;
}
</style>
